
define('text!libs/strand/src/shared/js/fetch.html',[],function () { return '<script src="../../../bower_components/fetch/fetch.js"></script>\n';});

